/**
 * resolveDefaultSession — pure session-selection helper.
 *
 * Rules (in order, no approval-count ranking):
 *   1. If storedRunId is present AND matches a session in the list → restore it.
 *      Stale storedRunId (run no longer in list) is silently ignored; fall to rule 2.
 *   2. If exactly ONE session exists → auto-select (trivially unambiguous).
 *   3. Multiple sessions, no stored identity → return null.
 *      Caller must show an explicit-selection prompt.
 *
 * A stale run or a run from a different site with more approvals is NEVER
 * silently promoted. Approval counts are intentionally not read here.
 *
 * @param {Array} sessions  Array of session objects (each must have s1_run_id).
 * @param {string|null} storedRunId  Value from sessionStorage, or null.
 * @returns {object|null}  The selected session, or null if explicit choice required.
 */
function resolveDefaultSession(sessions, storedRunId) {
  if (!sessions || sessions.length === 0) return null;
  // Rule 1 — exact identity match from explicit prior choice
  if (storedRunId) {
    const stored = sessions.find(s => s.s1_run_id === storedRunId);
    if (stored) return stored;
    // storedRunId present but not found → stale; fall through to Rule 2
  }
  // Rule 2 — single session, trivially unambiguous
  if (sessions.length === 1) return sessions[0];
  // Rule 3 — multiple sessions, no stored identity → require explicit choice
  return null;
}

module.exports = { resolveDefaultSession };
